import { pathOr, prop } from "ramda";
import { api, setter, fetchParams, fetchResponse } from "@/modules/helper";

export default {
  namespaced: true,

  state: {
    pagination: {
      skip: 0,
      limit: 12,
    },
    items: [],
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    items: prop("items"),
    count: pathOr(0, ["pagination", "count"]),
  },

  actions: {
    flush({ commit }) {
      commit("dynamicSet", {
        items: [],
        pagination: {
          count: 0,
        },
      });
    },

    create(state, payload) {
      return api.post("media", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },

    fetch({ commit, state }, payload) {
      return api
        .get("media", {
          params: fetchParams(state, payload, payload),
        })
        .then((data) => {
          if (data.skip !== 0) {
            data.data = state.items.concat(data.data);
          }

          return data;
        })
        .then((data) => commit("dynamicSet", fetchResponse(data)));
    },

    update(state, payload) {
      return api.patch(`media/${payload.id}`, payload);
    },

    remove(state, id) {
      return api.delete(`media/${id}`);
    },

    download(state, id) {
      return api.get(`media/${id}/download`).then(({ data }) => {
        window.location.href = data;
      });
    },

    exportData({ state }, payload) {
      return api.get("media/export", {
        responseType: "blob",
        params: fetchParams(state, payload, payload),
      });
    },
  },
};
